<template>
    <c-search-mobile-header-top class="search-mobile-header-top">
        <i :class="search_icon_class" @click="toggleDropdownSearch"></i>
        <div class="dropdown-search" :class="{ active: isActive }" @click="isActive = false">
            <div class="content-dropdown-search">
                <form method="get" :action="route_search" id="form_search_term_mb">
                    <input
                        type="search"
                        v-model="searchTerm"
                        name="search_term"
                        id="search_term_mb"
                        placeholder="O que você procura?"
                        value=""
                        @input="filterResults"
                        @click.prevent.stop
                    />
                    <button
                        id="btn_search_term_mb"
                        aria-label="Pesquisar"
                        type="submit"
                    >
                        <i class="fas fa-search"></i>
                    </button>
                </form>
                <div v-if="showResults" id="results-container" class="autocomplete-results">
                    <div
                        v-for="(item, idx) in filtered"
                        :key="item.id || idx"
                        :class="['autocomplete-item']"
                        @mousedown.prevent="selectItem(item)"
                    >
                        {{ item.pro_name_site }}
                    </div>
                    <div v-if="!isSearching && filtered.length === 0" class="emptymessage">Nenhum resultado encontrado!</div>
                </div>
            </div>
        </div>
    </c-search-mobile-header-top>
</template>

<script>
import { CSearchMobileHeaderTop } from "../Styles/Header/styled";

export default {
    name: "SearchMobileHeaderTop",
    props: {
        route_search: {
            required: true,
        },
        api_search_url: { required: true }
    },
    components: {
        "c-search-mobile-header-top": CSearchMobileHeaderTop
    },
    data() {
        return {
            isActive: false,
            searchTerm: "",
            apiSearchResult: [],
            filtered: [],
            showResults: false,
            searchDebounce: null,
            isSearching: false,
        };
    },
    beforeDestroy(){
        clearTimeout(this.searchDebounce);
    },

    methods: {
        toggleDropdownSearch() {
            this.isActive = !this.isActive;
        },
        buildSearchUrl(searchTerm) {
            const url = new URL(this.api_search_url, window.location.origin);
            url.searchParams.set('search_term', searchTerm);
            url.searchParams.set('limit', '20');
            return url.toString();
        },
        async getProducts(searchTerm){
            try {
                this.isSearching = true;
                const response = await fetch(this.buildSearchUrl(searchTerm), {
                    headers: {
                        'Accept': 'application/json'
                    }
                });
                this.apiSearchResult = await response.json();
                this.filtered = this.apiSearchResult;
                this.showResults = true;
            } catch (error) {
                console.error('Erro ao buscar dados da API:', error);
                this.filtered = [];
                this.showResults = false;
            } finally {
                this.isSearching = false;
            }
        },
        filterResults() {
            const searchTerm = this.searchTerm.trim();
            clearTimeout(this.searchDebounce);

            if (searchTerm.length < 3) {
                this.filtered = [];
                this.showResults = false;
                this.isSearching = false;
                return;
            }

            this.searchDebounce = setTimeout(() => {
                this.getProducts(searchTerm);
            }, 300);
        },
        selectItem(item) {
            this.searchTerm = item.pro_name_site;
            this.showResults = false;
            this.filtered = [];
             setTimeout(() => {
                 this.$nextTick(() => {
                     document.getElementById('btn_search_term_mb').click();
                 });
             }, 1000);
        },
    },
    computed: {
        search_icon_class() {
            return this.$root.$children[0].theme?.header?.search?.search_icon_class ?? 'fas fa-search'
        }
    }
};
</script>

<style scoped>
    .autocomplete-results {
        position: absolute;
        background: #fff;
        border: 1px solid #ccc;
        width: 100%;
        z-index: 10;
        border-top: none;
        max-height: 200px;
        overflow-y: auto;
        padding: .8rem 1rem;
    }
    .autocomplete-item {
        padding: 8px;
        cursor: pointer;
    }
    .autocomplete-item:hover {
        background: #eee;
    }
    .autocomplete-active {
        background: #eee;
    }
    .emptymessage {
        padding: 8px;
        color: #999;
    }
</style>
